<template>
  <div id="userlayout" class="userlayout space_between full_layout" v-loading.fullscreen="loading">
    <div class="userLeft">
      <div class="userhead">
        <span :class="userInfo.Level>1?'lv lv'+userInfo.Level:''">
          <img src="../../../static/images/userHeadPortrait.svg">
        </span>
        <div>{{userInfo.NickName}}</div>
      </div>
      <ul class="userMenu">
        <li :class="(isWhat[0]=='user'&&isWhat[1]=='info')?'on':''">
          <router-link :to="{path:'/user/info'}">Personal information</router-link>
        </li>
        <li :class="(isWhat[0]=='user'&&isWhat[1]=='order')?'on':''">
          <router-link :to="{path:'/user/order'}">My orders</router-link>
        </li>
        <!-- <li>
          <router-link :to="{path:'/message'}">我的消息</router-link>
        </li> -->
        <li :class="(isWhat[0]=='user'&&isWhat[1]=='address')?'on':''">
          <router-link :to="{path:'/user/address'}">My addresses</router-link>
        </li>
        <li>
          <router-link :to="{path:'/cart'}">Shopping cart</router-link>
        </li>
        <!-- <li :class="(isWhat[0]=='user'&&isWhat[1]=='point')?'on':''">
          <router-link :to="{path:'/user/point'}">Points</router-link>
        </li>
        <li :class="(isWhat[0]=='user'&&isWhat[1]=='exchange')?'on':''">
          <router-link :to="{path:'/user/exchange'}">Cypher</router-link>
        </li> -->
        <li @click="logout">
          <span>Sign out</span>
        </li>
      </ul>
    </div>
    <router-view @updata="updata"></router-view>
  </div>
</template>
<script>
import { getInfo,toLogout} from "@/api/public";
export default {
  name: 'userlayout',
  components: { },
  data() {
    return {
      userInfo:getInfo(),
      loading:false,
      isWhat:this.$route.path.slice(1).split("/"),
    }
  },
  watch:{
    '$route':'getPath'
  },
  mounted() {
    this.$root.$on("newName",val => {
      this.userInfo=getInfo()
    })
  },
  created() {
    if(this.userInfo!=null){}
    
    //this.userInfo=getInfo()
  },
  methods: {
    updata(val){
      if(val=='info'){
        this.userInfo=getInfo()
      }
    },
    logout(){
      this.loading=true;
      toLogout()
    },
    getPath(){
      this.isWhat=this.$route.path.slice(1).split("/")
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";

</style>



// WEBPACK FOOTER //
// src/pages/user/userlayout.vue